<template>
  <div
    class="stream-indicator"
    :class="{ playing: (state === 'playing') }"
    @click="$emit('click')"
  >
    <animated-icon
      v-if="state === 'buffering'"
      path="/static/animations/spinner.json"
      class="spinner-icon"
    />
    <animated-icon
      v-else-if="state === 'playing'"
      path="/static/animations/streaming.json"
      class="streaming-icon"
    />
    <animated-icon
      v-else-if="state === 'error'"
      path="/static/animations/error.json"
      class="error-icon"
      :loop="false"
      @complete="setError(null)"
    />
    <img v-else-if="state === 'pause'" src="~@/assets/icon-play.svg" class="stream-icon">
    <img v-else src="~@/assets/icon-no-stream.svg" class="stream-icon">
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import AnimatedIcon from '@/components/common/AnimatedIcon';

export default {
  name: 'StreamIndicator',
  components: {
    AnimatedIcon,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    state: {
      type: String,
      default: 'paused',
    },
  },
  methods: {
    ...mapMutations('playback', ['setError']),
  },
};
</script>

<style lang="scss" scoped>
.stream-indicator {
  border-radius: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 0 auto;
  position: relative;
  width: 0.9em;
  height: 1.3765em;
  background-color: rgba(0, 0, 0, 0.1);
  cursor: pointer;

  &.playing {
      background-color: rgba(0, 0, 0, 0.05);
  }
}

.stream-icon {
  width: 75%;
}

.streaming-icon {
  height: 75%;
  width: 75%;
  margin: 0 auto;
}

.spinner-icon,
.error-icon {
  height: 95%;
  width: 95%;
  margin: 0 auto;
}
</style>
